import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

interface ShellState {
	isRouteLoading: boolean;
	isSidebarSectionOpen: (sectionId: string) => boolean;
	setRouteLoading: (isLoading: boolean) => void;
	setSidebarSectionOpen: (sectionId: string, isOpen: boolean) => void;
	/** Section open map keyed by group titleKey. Missing key = open. */
	sidebarSectionOpen: Record<string, boolean>;
}

export const useShellStore = create<ShellState>()(
	persist(
		immer((set, get) => ({
			isRouteLoading: false,
			sidebarSectionOpen: {},
			setRouteLoading: (isLoading) => {
				set((state) => {
					state.isRouteLoading = isLoading;
				});
			},
			isSidebarSectionOpen: (sectionId) => get().sidebarSectionOpen[sectionId] !== false,
			setSidebarSectionOpen: (sectionId, isOpen) => {
				set((state) => {
					state.sidebarSectionOpen[sectionId] = isOpen;
				});
			},
		})),
		{
			name: "tg.shell",
			storage: createJSONStorage(() => localStorage),
			partialize: (state) => ({
				sidebarSectionOpen: state.sidebarSectionOpen,
			}),
		}
	)
);
